export default __webpack_public_path__ + "static/media/physical-touch.a8e17595.png";